import React from 'react'
import { Button } from '@mote/ui'
import { useDownloadCurrentUsersMutation } from '@mote/api'
import { TickIcon } from '@mote/assets/icons'

export const EmailMeMyUsersButton = () => {
  const [buttonText, setButtonText] = React.useState('Email me my users')
  const {
    mutate: emailMyUsers,
    data,
    error,
    loading,
    flush
  } = useDownloadCurrentUsersMutation()

  async function handleEmailMyUsers() {
    flush()
    await emailMyUsers()
  }

  React.useEffect(() => {
    if (loading) return setButtonText('Working ...')

    if (data && !error) {
      setButtonText('Email is on its way!')
      setTimeout(() => setButtonText('Email me my users'), 2000)
      return
    }

    if (error) {
      return setButtonText('Please contact support')
    }

    setButtonText('Email me my users')
  }, [loading, data, error])

  return (
    <Button
      icon={
        data && !error && buttonText !== 'Email me my users' ? (
          <TickIcon />
        ) : null
      }
      variant='link'
      text={buttonText}
      size='sm'
      disabled={loading}
      onClick={handleEmailMyUsers}
    />
  )
}
